export const normalizeCase = (name: string) => {
  if (name == null) {
    return
  }
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
}
